/* global imagesLoaded, Isotope */
export default class MasonryGallery {
    constructor(gallery) {
        if (!gallery) {
            return;
        }
        this.gallery = gallery;

        this.init();

        this.events();
    }

    getSiblings(e) {
        // for collecting siblings
        let siblings = [];

        // if no parent, return no sibling
        if(!e.parentNode) {
            return siblings;
        }

        // first child of the parent node
        let sibling  = e.parentNode.firstChild;

        // collecting siblings
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== e) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
        return siblings;
    }

    init() {
        if (this.gallery.dataset.isotope) {
            this.iso = new Isotope( this.gallery, JSON.parse(this.gallery.dataset.isotope));
            imagesLoaded(this.gallery).on('progress', () => {
				this.iso.layout();
			});
        }

        setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
        }, 1000);
    }

    events() {
        document.querySelectorAll('.masonry-gallery-filters li a[data-filter]').forEach( el => {
            el.addEventListener('click', ev => {
                ev.preventDefault();
                this.iso.arrange({filter: ev.currentTarget.dataset.filter});
                this.getSiblings(ev.currentTarget.parentNode).map(e => e.querySelector('a').classList.remove('active'));
                ev.currentTarget.classList.add('active');
            }, false);
        });
    }
}
